import { useEffect, useState } from "react";
import { usersService } from "../../services/usersService";
import { User } from "../../utils/database";
import useToken from "./useToken";

export default function useCurrentUser() {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  const { token } = useToken();

  const getCurrentUser = async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await usersService.getCurrentUser(token);
      setCurrentUser(response);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching current user:", error);
      setError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getCurrentUser();
  }, [token]);

  return {
    currentUser,
    loading,
    error,
    refreshUser: getCurrentUser,
  };
}
